import { render, staticRenderFns } from "./NbLoginPassInput.vue?vue&type=template&id=1c1bd42f&scoped=true&"
import script from "./NbLoginPassInput.vue?vue&type=script&lang=js&"
export * from "./NbLoginPassInput.vue?vue&type=script&lang=js&"
import style0 from "./NbLoginPassInput.vue?vue&type=style&index=0&id=1c1bd42f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c1bd42f",
  null
  
)

export default component.exports